export default __webpack_public_path__ + "static/media/faqquestion.8a63be65.svg";